import { useCallback, useMemo } from 'react';

import { AppServiceFactory } from '@/modules/app/service/AppServiceFactory';

export const useVersioning = () => {
  const appSvc = useMemo(() => AppServiceFactory.getInstance().createAppService(), []);

  const loadVersion = useCallback((id: string) => appSvc.loadVersion(id), [appSvc]);

  const finalizeRevision = useCallback(() => appSvc.finalizeRevision(), [appSvc]);

  const restoreVersion = useCallback(() => appSvc.restoreRevision(), [appSvc]);

  return {
    loadVersion,
    finalizeRevision,
    restoreVersion,
  };
};
